export enum SimpleTableGroupState {
  Visible = 'visible',
  Inactive = 'inactive',
  Hidden = 'hidden'
}
